import { Link } from "react-router-dom";
import { Heart, Phone, Mail, MapPin, Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-secondary/50 border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Contact */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Heart className="h-8 w-8 text-primary" fill="currentColor" />
              <span className="text-xl font-bold text-gradient-hero">
                Groomie Roomie
              </span>
            </div>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Phone className="h-4 w-4" />
                <a href="tel:+17209738622" className="hover:text-primary transition-colors">
                  (720) 973-8622
                </a>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Mail className="h-4 w-4" />
                <span>groomieroomie@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <MapPin className="h-4 w-4" />
                <span>2145 S Newport St, Denver, CO 80224</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/services" className="block text-muted-foreground hover:text-primary transition-colors">
                Services
              </Link>
              <Link to="/booking" className="block text-muted-foreground hover:text-primary transition-colors">
                Book Appointment
              </Link>
              <Link to="/gallery" className="block text-muted-foreground hover:text-primary transition-colors">
                Gallery
              </Link>
              <Link to="/about" className="block text-muted-foreground hover:text-primary transition-colors">
                About Us
              </Link>
              <Link to="/contact" className="block text-muted-foreground hover:text-primary transition-colors">
                Contact
              </Link>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Resources</h3>
            <div className="space-y-2">
              <Link to="/blog" className="block text-muted-foreground hover:text-primary transition-colors">
                Blog
              </Link>
              <Link to="/faq" className="block text-muted-foreground hover:text-primary transition-colors">
                FAQ
              </Link>
              <Link to="/sitemap" className="block text-muted-foreground hover:text-primary transition-colors">
                Sitemap
              </Link>
              <a href="#" className="block text-muted-foreground hover:text-primary transition-colors">
                Terms of Service
              </a>
              <Link to="/privacy-policy" className="block text-muted-foreground hover:text-primary transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="block text-muted-foreground hover:text-primary transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/groomie_roomie_denver_?igsh=MTdxcWo5MHRmYnk1bQ=="
                className="p-2 rounded-full bg-primary/10 text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Groomie Roomie on Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.tiktok.com/@groomie_roomie_denver?_t=ZN-90A9A1Cr9jK&_r=1"
                className="p-2 rounded-full bg-primary/10 text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Groomie Roomie on TikTok"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.321 5.562a5.124 5.124 0 01-.443-.258 6.228 6.228 0 01-1.137-.966c-.849-.952-1.223-2.073-1.223-3.338V1h-3.27v14.26c0 2.024-1.644 3.668-3.668 3.668S6.912 17.284 6.912 15.26s1.644-3.668 3.668-3.668c.377 0 .741.057 1.086.163V8.49a7.925 7.925 0 00-1.086-.074c-4.124 0-7.668 3.544-7.668 7.668S6.456 23.752 10.58 23.752s7.668-3.544 7.668-7.668V9.721a9.13 9.13 0 004.494 1.157V7.611a5.152 5.152 0 01-3.421-2.049z"/>
                </svg>
              </a>
            </div>
            <p className="text-sm text-muted-foreground mt-4">
              Tag us @groomieroomie to be featured as Pet of the Month! 📸
            </p>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-muted-foreground text-sm">
          <p>&copy; 2024 Groomie Roomie. All rights reserved. Made with ❤️ for pets in Denver.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;